import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Web development services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What is web development?',
      description: `A: Web development refers to the process of creating and maintaining websites or web applications that are accessible via the internet. It involves a range of tasks, including designing the layout and user interface (UI), writing code to implement functionality, and integrating various components to ensure smooth operation. Web development encompasses both front-end development, which focuses on the visual aspects and user experience, and back-end development, which involves server- or cloud-side programming and database management. Web developers use a variety of programming languages, frameworks, and tools to build websites and web applications that meet the needs of businesses and users alike. Overall, web development plays a crucial role in enabling businesses to establish an online presence, interact with customers, and provide valuable services and information.`,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },

    {
      title: 'Q: What type of web development services does Rumble Fish offer?',
      description: `A: At Rumble Fish, we offer a wide array of web development services tailored to meet the diverse needs of our clients. Our services encompass everything from front-end development, where we create engaging and responsive user interfaces, to back-end development, ensuring robust functionality and seamless integration with databases and other systems. We specialize in full-stack development, providing end-to-end solutions that encompass both front-end and back-end aspects of web development. Additionally, our expertise extends to e-commerce development, content management systems (CMS) customization, API integration, branding and design, and web application development. Whatever your web development needs may be, Rumble Fish is committed to delivering innovative solutions that elevate your online presence and drive success.`,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },
    {
      title: 'Q: Why hire Rumble Fish for web product development?',
      description: `A:
        Hiring Rumble Fish for web product development offers numerous benefits that can greatly enhance your project's success:
        <br />
        <ul>
          <li>
            <b>Expertise: </b>
             Rumble Fish boasts a team of highly skilled professionals with extensive experience in web development. Our expertise spans a wide range of technologies, ensuring that we can tackle projects of varying complexity with confidence.
          </li>
          <li>
            <b>Custom Solutions: </b>
            We understand that every project is unique, and we tailor our solutions to meet your specific needs. Whether you require a simple website or a complex web application, we have the expertise to deliver a custom solution that aligns with your goals.
          </li>
          <li>
            <b>Focus on User Experience: </b>
            At Rumble Fish, we prioritize user experience in all our projects. We design intuitive interfaces and seamless navigation to ensure that your users have a positive experience when interacting with your web product.
          </li>
          <li>
            <b>Quality Assurance: </b>
            Quality is at the forefront of everything we do. We employ rigorous testing processes to identify and address any issues before your web product goes live, ensuring that it performs flawlessly and meets your expectations.
          </li>
          <li>
            <b>Timely Delivery: </b>
            We understand the importance of meeting deadlines, and we work diligently to deliver projects on time and within budget. Our efficient project management ensures that your web product is completed according to schedule.
          </li>
          <li>
            <b>Ongoing Support: </b>
            Our relationship with clients doesn't end once the project is complete. We offer ongoing support and maintenance services to ensure that your web product continues to perform optimally long after it's launched.
          </li>
        </ul>
      `,
      gradientOnFocus: theme.mixins.aquamarineGradient?.background as string,
    },
  ];
};
